import { loadRecommendationsRoutine, dismissRecommendationRoutine } from './actions'
import { contextKey, initialContextState, initialState } from './state'

const deriveBadge = (items) => {
  let critical = 0
  let medium = 0
  for (const item of items) {
    if (item.tier === 'critical') critical += 1
    else if (item.tier === 'medium') medium += 1
  }
  const tier = critical > 0 ? 'critical' : medium > 0 ? 'medium' : null
  return { tier, count: critical + medium }
}

const updateContext = (state, contextType, contextId, partial) => {
  const key = contextKey(contextType, contextId)
  const prev = state.byContext[key] || initialContextState()
  return {
    ...state,
    byContext: { ...state.byContext, [key]: { ...prev, ...partial } },
  }
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case loadRecommendationsRoutine.REQUEST: {
      const { contextType, contextId } = action.payload || {}
      if (!contextType || !contextId) return state
      return updateContext(state, contextType, contextId, { loading: true, error: null })
    }

    case loadRecommendationsRoutine.SUCCESS: {
      const { contextType, contextId, items } = action.payload
      return updateContext(state, contextType, contextId, {
        items,
        badge: deriveBadge(items),
        loading: false,
        error: null,
        fetchedAt: Date.now(),
      })
    }

    case loadRecommendationsRoutine.FAILURE: {
      const { contextType, contextId, error } = action.payload
      return updateContext(state, contextType, contextId, { loading: false, error, fetchedAt: Date.now() })
    }

    case dismissRecommendationRoutine.SUCCESS: {
      const { signature, scope, contextType, contextId } = action.payload
      const key = contextKey(contextType, contextId)
      const prev = state.byContext[key] || initialContextState()
      const items = prev.items.filter(item => item.signature !== signature)
      return {
        ...state,
        byContext: {
          ...state.byContext,
          [key]: { ...prev, items, badge: deriveBadge(items) },
        },
        dismissals: { ...state.dismissals, [signature]: { scope } },
      }
    }

    default:
      return state
  }
}
